import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { NavIcon } from '../NavIcon'
import { NavLinkConfig } from '../useNavigationItems'

import { ReactComponent as ApplicationDrawerIcon } from '@percent/workplace-giving/assets/icons/nav/application-drawer.svg'
import classes from './BottomTabBar.module.scss'

type BottomTabBarProps = {
  tabs: NavLinkConfig[]
  isMenuOpen: boolean
  onMenuToggle: () => void
}

export function BottomTabBar({ tabs, isMenuOpen, onMenuToggle }: Readonly<BottomTabBarProps>) {
  const { t } = useTranslation()

  return (
    <nav aria-label={t('workplace_giving.navigation.primaryNavigation')} className={classes.tabBar}>
      {tabs.map(tab => (
        <NavLink
          key={tab.key}
          className={({ isActive }) => (isActive ? `${classes.tab} ${classes.tabActive}` : classes.tab)}
          data-testid={`bottom-tab-${tab.key}`}
          end={tab.end}
          to={tab.to}
        >
          <span className={classes.tabIcon}>
            <NavIcon name={tab.icon} />
          </span>
          <span className={classes.tabLabel}>{tab.shortLabel}</span>
        </NavLink>
      ))}

      <button
        aria-expanded={isMenuOpen}
        className={classes.tab}
        data-testid="bottom-tab-more"
        onClick={onMenuToggle}
        type="button"
      >
        <span className={classes.tabIcon}>
          <ApplicationDrawerIcon />
        </span>
        <span className={classes.tabLabel}>{t('workplace_giving.common.more')}</span>
      </button>
    </nav>
  )
}
